import { gql } from '@apollo/client'

export default gql`
  fragment EmployeeBU on Employee {
    id
    businessUnit {
      id
      name
    }
  }
`
